var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shasRow",class:{
    gilyonHover: _vm.secHover && _vm.section.gilyon,
    shasSectionSelected:
      _vm.shasSecSelected.length && _vm.section && _vm.isSectionSelected,
    shasSectionHover: _vm.secHover,
  },attrs:{"page":_vm.page},on:{"mouseenter":function($event){return _vm.$emit('mouseenter')},"mouseleave":function($event){return _vm.$emit('mouseleave')},"click":[function($event){if(!$event.ctrlKey){ return null; }$event.stopPropagation();return _vm.selectShasSec(true)},function($event){if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.selectShasSec(false)}]}})}
var staticRenderFns = []

export { render, staticRenderFns }